import { render, staticRenderFns } from "./AnuncioPremium.vue?vue&type=template&id=4d6b7bca&scoped=true"
import script from "./AnuncioPremium.vue?vue&type=script&lang=js"
export * from "./AnuncioPremium.vue?vue&type=script&lang=js"
import style0 from "./AnuncioPremium.vue?vue&type=style&index=0&id=4d6b7bca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6b7bca",
  null
  
)

export default component.exports